import React, { useEffect, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import theme from 'v3/theme';

function FilterSelector({ handleFilterOptionSelected, currentValue, ...props }) {
  const [selected, setSelected] = useState(Number(currentValue) || null);

  useEffect(() => {
    setSelected(Number(currentValue) || null);
  }, [currentValue]);

  useEffect(() => {
    handleFilterOptionSelected(selected);
  }, [selected]);

  function handleSelected(event, value) {
    setSelected(value);
  }

  return (
    <ToggleButtonGroup value={selected} onChange={handleSelected} size="large" exclusive>
      <ToggleButton value={1} style={{ color: theme.colors.dark, fontWeight: 500 }}>
        todos os clientes
      </ToggleButton>
      <ToggleButton value={2} style={{ color: theme.colors.dark, fontWeight: 500 }}>
        por cliente
      </ToggleButton>
      <ToggleButton value={3} style={{ color: theme.colors.dark, fontWeight: 500 }}>
        por tag
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default FilterSelector;
